import React from "react";
import { Phone } from "lucide-react";
import { SITE } from "../lib/site";

/**
 * Bandeau rouge collé en haut du site (sticky), comme sur sos-serrurier-express.fr.
 * Texte unique + numéro très visible et cliquable sur mobile.
 */
export default function TopRedBanner() {
  return (
    <div
      data-testid="top-red-banner"
      className="bg-[#DC2626] text-white border-b border-red-700 sticky top-0 z-50 w-full shadow-sm"
      role="banner"
    >
      <div className="container-x py-2.5 sm:py-3 flex items-center justify-center gap-2 sm:gap-3 text-center text-sm sm:text-[15px]">
        <Phone className="w-4 h-4 sm:w-5 sm:h-5 shrink-0 animate-pulse-emergency" strokeWidth={2.5} />
        <span className="font-medium leading-tight">
          <span className="hidden sm:inline">Électricien en 30 minutes — Appelez le </span>
          <span className="sm:hidden">Électricien 30 min — </span>
          <a
            href={`tel:${SITE.phoneTel}`}
            data-testid="top-banner-phone"
            className="font-extrabold underline underline-offset-2 hover:text-yellow-200 whitespace-nowrap text-base sm:text-lg tracking-wide"
          >
            {SITE.phoneDisplay}
          </a>
        </span>
      </div>
    </div>
  );
}
